import { useEffect, useState } from "react";
import problemServices from "app/services/problem-service";

const useProblemDetailsById = (id) => {
  const [problemDetailsById, setProblemDetailsById] = useState(null);
  const [loading, setLoading] = useState(false); // Start false to avoid initial load
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProblemDetailsById = async () => {
      setLoading(true);
      try {
        const res = await problemServices.getProblemById(id);
        if (!res) {
          console.warn("No problem data returned for id:", id);
          setProblemDetailsById(null);
        } else {
          setProblemDetailsById(res);
        }
      } catch (error) {
        console.error("Error fetching problem details by id:", error);
        setProblemDetailsById(null);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchProblemDetailsById();
    }
  }, [id]);

  return { problemDetailsById, loading, error };
};

export default useProblemDetailsById;
